import { GeneralStats } from "../interfaces/stats";
import { api } from "./api";

export const getGeneralStats = async () => {
  const { data } = await api.get<GeneralStats>(`/api/v1/general_stats`);
  return data;
};
